async function getRawShipmentsById (state, params = {}) {
  const { shipmentId } = params

  if (!shipmentId || shipmentId === '') {
    const err = new Error('ShipmentId parameter is required')
    err.status = 400
    throw err
  }

  try {
    const response = await state.dal.shipment.getAllDocsWithPrefix(state.shipmentsDb, shipmentId)
    const rows = response && response.rows ? response.rows : []
    if (!rows.length) {
      return []
    }

    return rows
      .map(row => row.doc)
      .filter(Boolean)
  } catch (err) {
    const error = new Error(`Error getting raw shipment docs: ${err.message}`)
    error.status = err.status || 500
    throw error
  }
}

module.exports = getRawShipmentsById
